module.exports = __webpack_public_path__ + "static/media/hoodScreenshot.9051986b.png";